import { css } from '@emotion/react';
import * as React from 'react';

import authInfo from '../../services/authInfo';
import colors from '../../theme/colors';
import { toDate } from '../../utils/date';
import Confetti from '../core/Confetti';
import Heading from '../core/Heading';

const HappyBirthday = () => {
  const [show, setShow] = React.useState(true);

  React.useEffect(() => {
    setTimeout(() => {
      setShow(false);
      localStorage.setItem(`birthday-${new Date().getFullYear()}`, 'true');
    }, 7000);
  }, []);

  const dateOfBirth = authInfo.dateOfBirth ? toDate(authInfo.dateOfBirth) : null;

  if (
    show &&
    dateOfBirth &&
    !localStorage.getItem(`birthday-${new Date().getFullYear()}`) &&
    new Date().getDate() === dateOfBirth.getDate() &&
    new Date().getMonth() === dateOfBirth.getMonth()
  ) {
    return (
      <>
        <div
          css={css`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 9999999999;
          `}
        >
          <Heading type="h1" color={colors.cornflower}>
            Happy birthday {authInfo.currentUserFirstName} {authInfo.currentUserLastName}!
          </Heading>
        </div>
        <Confetti fireOnMount times={5} />
      </>
    );
  }

  return null;
};

export default HappyBirthday;
